(() => {
  'use strict';
  const avatar = document.currentScript && document.currentScript.dataset.avatar;
  if (!avatar) return;
  const widgetId = '_5fk7mdy7';
  const iconSelector = 'img[alt="Launcher icon"]';
  let widget;

  function updateImage(image) {
    if (!image.matches(iconSelector)) return;
    if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
    if (image.getAttribute('src') !== avatar) image.setAttribute('src', avatar);
    if (image.style.objectFit !== 'contain') image.style.objectFit = 'contain';
    if (image.style.borderRadius !== '50%') image.style.borderRadius = '50%';
  }

  function updateWithin(node) {
    if (node.nodeType !== 1) return;
    updateImage(node);
    node.querySelectorAll(iconSelector).forEach(updateImage);
  }

  const widgetObserver = new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes') updateImage(record.target);
      else record.addedNodes.forEach(updateWithin);
    });
  });

  // Watch direct ancestors only so replacing the widget (or its wrapper) can
  // restart discovery without observing unrelated page images and app DOM.
  const removalObserver = new MutationObserver(records => {
    const moved = records.some(record => [...record.removedNodes].some(node =>
      node === widget || (node.nodeType === 1 && node.contains(widget))));
    if (!moved) return;
    if (widget.isConnected) watchRemoval();
    else discover();
  });

  function watchRemoval() {
    removalObserver.disconnect();
    for (let parent = widget.parentNode; parent; parent = parent.parentNode) {
      removalObserver.observe(parent, { childList: true });
    }
  }

  const discoveryObserver = new MutationObserver(() => {
    if (document.getElementById(widgetId)) discover();
  });

  function discover() {
    discoveryObserver.disconnect();
    widgetObserver.disconnect();
    removalObserver.disconnect();
    widget = document.getElementById(widgetId);
    if (!widget) {
      discoveryObserver.observe(document.body, { childList: true, subtree: true });
      return;
    }
    updateWithin(widget);
    widgetObserver.observe(widget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'alt']
    });
    watchRemoval();
  }

  discover();
})();
